<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-owners-list'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full relative">
      <app-feature-flag-tabs class="w-full">
        <ng-container navTabs>
          <sbnb-page-header class="absolute top-0 left-0"></sbnb-page-header>
          <div
            class="flex mb-8 items-center justify-center sbnbDesktop:justify-start flex-col sbnbDesktop:flex-row gap-2">
            <h2 class="flex-1 mb-0">Owners</h2>
            <sbnb-button size="mini" label="+ Add Owner" [routerLink]="['./add']"></sbnb-button>
          </div>
        </ng-container>
        <div class="flex mb-8">
          <h2 class="flex-1 mb-0">Owners</h2>
          <sbnb-button size="mini" label="+ Add Owner" [routerLink]="['./add']"></sbnb-button>
        </div>
      </app-feature-flag-tabs>

      <div *ngIf="ownersState$ | async as state">
        <div *ngIf="state.data?.length && !state.loading && !state.error" class="overflow-x-auto w-full">
          <table mat-table class="w-full min-w-[720px]" [dataSource]="state.data">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.type === 'individual' ? element.firstName + ' ' + element.name : element.name }}
              </td>
            </ng-container>

            <!-- Phone Column -->
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>Phone</th>
              <td mat-cell *matCellDef="let element">{{ element.phone ?? '-' }}</td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let element">{{ element.email ?? '-' }}</td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Type</th>
              <td mat-cell *matCellDef="let element">{{ element.type | titlecase }}</td>
            </ng-container>

            <!-- Properties Column -->
            <ng-container matColumnDef="properties">
              <th mat-header-cell *matHeaderCellDef>Properties</th>
              <td mat-cell *matCellDef="let element">
                <div *ngIf="element.properties.length > 0" class="flex">
                  <sbnb-avatar-group
                    [items]="element.properties"
                    itemsLabel="properties"
                    [itemsForLabel]="element.name"></sbnb-avatar-group>
                </div>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <sbnb-button size="mini" type="secondary" label="Edit"></sbnb-button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              class="hover:bg-smoke-lighter cursor-pointer"
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [routerLink]="['./', row.id]"></tr>
          </table>
        </div>

        <div *ngIf="!state.loading && !state.error && state.data.length === 0">No Owners yet</div>

        <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

        <div class="error" *ngIf="state.error">{{ state.error }}</div>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
